<template>
  <ContentTemplate title="Login Activity" :container-size-small="true" style="margin-bottom: 40px;">
    <form>

      <div class="form-group">
        <div class="row">
          <div class="col-4">
            <FormGroupLabelSection
                label="Active Sessions"
                icon="MapPin"
                icon-type="fal"
            />
          </div>
          <div class="col-8">
            <LoginActivitySection v-for="(item, index) in activityList"
                                  :key="index"
                                  :activity="item"
                                  :with-button="true" :is-disable="false"
                                  @deleteActivity="onDeleteActivity(item.id)"
            />
          </div>
        </div>
      </div>

      <div class="fp-form-group">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-8 d-flex justify-content-end mt-2">
            <ButtonElement
                class="btn--ms btn--accent"
                @clickOnButton="deleteAllActivity()">
              Log out of all sessions
            </ButtonElement>
          </div>
        </div>
      </div>

    </form>
  </ContentTemplate>

</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {AccountNs, CommonNs} from '@shared/types'
import {ButtonElement, ContentTemplate, FormGroupLabelSection, LoginActivitySection} from "@shared/components";
import {mapStores} from "pinia";
import {useAccountStore} from "@domains/account/stores/account.store";
import {useGeneralStore} from "@shared/stores/general.store";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'LoginActivityView',
  components: {
    ButtonElement,
    ContentTemplate,
    LoginActivitySection,
    FormGroupLabelSection
  },
  computed: {
    ...mapStores(useAccountStore, useGeneralStore),
  },
  data() {
    return {
      activityList: [] as AccountNs.LoginActivity[],
      loginActivityForm: {} as CommonNs.InputFormGroup
    }
  },
  beforeMount(): void {
    this.initData()
  },
  methods: {
    initData(): void {
      this.activityList = this.accountStore.getLoginActivities
    },

    onDeleteActivity(loginId: string) {
      this.accountStore.logoutFromDevice(loginId).then(() => {
        toast.success('Successfully logged out');
        this.initData()
      })
    },

    deleteAllActivity() {
      this.accountStore.logoutFromAllDevices().then(() => {
        toast.success('All sessions closed successfully');
        this.goToSignIn()
      })
    },

    goToSignIn(): void {
      this.$router.push('/auth/sign-in')
    }
  }
})
</script>

<style lang="scss" scoped>

hr {
  margin: 30px 0;
}

.fp-form-group {
  & .description {
    font-size: var(--fs-14);
    color: var(--text-neutral);
    margin: var(--space-0);

    p {
      font-size: var(--fs-12);
      color: var(--text-neutral);
      margin: var(--space-0);
    }
  }

  & .attention {
    font-size: var(--fs-12);
    color: var(--red-100);
    margin: var(--space-0);

    p {
      font-size: var(--fs-12);
      color: var(--red-100);
      margin: var(--space-0);
    }
  }
}
</style>
